// extracted by mini-css-extract-plugin
module.exports = {"aside":"styles_aside__UWBan","rotate":"styles_rotate__FLe9Z","rotate-reverse":"styles_rotate-reverse__s2_hs"};